// extracted by mini-css-extract-plugin
module.exports = {"devices":"DeviceSwitch_devices__oAYPQ","button":"DeviceSwitch_button__1nKVw","active":"DeviceSwitch_active__nx4Jo","icon":"DeviceSwitch_icon__2eYma"};